import { API, graphqlOperation } from "aws-amplify";
import { participantValidator } from "./inputFieldValidation.js";
import { updateProject } from "../../graphql/mutations";

const cleanParticipant = (participant) => ({
  email: typeof participant.email === "string" ? participant.email.trim() : participant.email,
  firstName: typeof participant.firstName === "string" ? participant.firstName.trim() : participant.firstName,
  lastName: typeof participant.lastName === "string" ? participant.lastName.trim() : participant.lastName,
  title: typeof participant.title === "string" ? participant.title.trim() : (participant.title || ""),
});

const AddParticipants = async (project, participants) => {

  try {
    for(let i = 0; i < participants.length; i++) {
      const participantValidation = participantValidator.validate(participants[i]);
      if(!(participantValidation.error === undefined)){
        throw new Error("Bad request");
      }   
    }
  } catch (error) {
    throw error;
  }

  const updatedProject = await API.graphql(
    graphqlOperation(updateProject, {
      id: project.id,
      projectName: project.projectName,
      participants: participants.map(cleanParticipant)
    })
  );
  return updatedProject;
  
};

export default AddParticipants;
